import React from 'react';
import IconButton from '@/components/buttons/IconButton';
import urls, { relativeUrl } from '@/constants/urls';

const HomeButton = () => (
  <IconButton
    className="aridhia-home-button primary"
    icon
    labelPosition="left"
    iconName="home"
    iconClassName="primary"
    messageId="fair.launcher.home"
    href={`#${relativeUrl(urls.HOME)}`}
  />
);

export default HomeButton;
